import React from 'react'

import { twMerge } from 'tailwind-merge'

interface TagProps {
  children: React.ReactNode
  className?: string
}

const Tag: React.FC<TagProps> = ({ children, className }) => {
  return (
    <div
      className={twMerge(
        ' p-2 bg-white rounded-full font-semimedium text-[12px] leading-[16px]',
        className,
      )}
    >
      {children}
    </div>
  )
}

export default Tag
